interface LogoProps {
  url?: string;
  float?: "left" | "right" | "none" | "inline-start" | "inline-end";
  display?: string;
  height?: string | number;
  width?: string | number;
  margin?: string;
}

function ClipboardLogo(props: LogoProps) {
  const urlString = props.url || `${process.env.REACT_APP_BASE_PATH || "/"}clipboard1_w.png`;
  return (
    <div
      className="logo"
      style={{
        float: props.float,
        display: props.display || "inline-block",
        height: props.height,
        width: props.width,
        background: `url("${urlString}") center center / contain no-repeat`,
        margin: props.margin || "0 0 0 0",
      }}
    />
  );
}

function BunnyLogo(props: LogoProps) {
  const urlString =
    props.url || `${process.env.REACT_APP_BASE_PATH || "/"}bunnyVerticalAgnostic.png`;
  return (
    <div
      className="logo"
      style={{
        float: props.float,
        height: props.height,
        width: props.width,
        background: `url("${urlString}") center center / contain no-repeat`,
        margin: props.margin || "0 0 0 0",
      }}
    />
  );
}

export { ClipboardLogo, BunnyLogo };
